<template>
    <div class="it-hero-text-wrapper bg-dark pt-0 pe-0">
        <h1 class="hero-title mt-5">Codice dei Contratti Pubblici Digitalizzato</h1>
        <div class="d-flex mb-5">
            <div class="view-toggle-container">
                <button @click="this.$parent.toggleView"
                    class="btn btn-sm btn-outline-primary d-flex align-items-center mt-3 me-2"
                    :title="this.$parent.classicView ? 'Passa alla vista standard' : 'Passa alla vista classica'">
                    <span class="d-none d-md-inline my-auto">{{ this.$parent.classicView ? 'Consultazione classica' :
                        'Consultazione standard' }}</span>
                    <font-awesome-icon class="ms-0 ms-md-2"
                        :icon="this.$parent.classicView ? 'list' : 'bars'"></font-awesome-icon>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faList, faBars } from '@fortawesome/free-solid-svg-icons'

library.add(faList, faBars);

export default {
    name: "HeroCard",
    components: {
        FontAwesomeIcon
    }
}
</script>

<style>
.it-hero-wrapper {
    margin-top: 2em !important;
}

.it-hero-wrapper .it-hero-text-wrapper {
    padding: 0 !important;
    padding-bottom: 1em !important;
}

.hero-title {
    font-family: 'Titillium Web', serif;
    font-weight: 700;
    font-size: 2.25rem !important;
    line-height: 1.2;
    margin-bottom: 1rem;
    letter-spacing: -0.02em;
}

.hero-description {
    font-family: 'Lora', serif;
    font-weight: 400;
    font-size: 1.125rem;
    line-height: 1.6;
    max-width: 90%;
    letter-spacing: 0.01em;
}

.it-hero-text-wrapper {
    transition: height 0.25s ease-in;
}

@media (min-width: 992px) {
    .hero-title {
        font-size: 2.5rem !important;
    }

    .hero-description {
        font-size: 1.25rem;
        max-width: 80%;
    }

    .it-hero-wrapper {
        padding-top: 5rem !important;
    }
}

@media (max-width: 992px) {
    .it-hero-wrapper {
        padding-top: 5.4em !important;
        padding-bottom: 3.8em !important;
    }

    .hero-title {
        font-size: 2rem !important;
    }
}
</style>